import { useMemo, useState } from 'react';
import { Cross2Icon } from '@radix-ui/react-icons';
import { Button } from '@/components/ui/button.tsx';
import { SearchInput } from '@/components/search-input.tsx';
import { TPlantWithAccessControl } from './user-plant-access-management.tsx';

// eslint-disable-next-line react-refresh/only-export-components
export function useUserPlantAccessDesktopFilters(plants: TPlantWithAccessControl[]) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredPlants = useMemo(() => {
    return plants.filter((plant) => {
      return (
        searchQuery === '' ||
        plant.basicDetails.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  }, [plants, searchQuery]);

  const isFiltered = searchQuery !== '';

  return {
    searchQuery,
    setSearchQuery,
    filteredPlants,
    isFiltered,
  };
}

export type UserPlantAccessDesktopFilters = ReturnType<
  typeof useUserPlantAccessDesktopFilters
>;

export function UserPlantAccessDesktopToolbar({
  filters,
}: {
  filters: UserPlantAccessDesktopFilters;
}) {
  const { searchQuery, setSearchQuery, isFiltered } = filters;

  return (
    <div className="flex flex-wrap gap-2">
      <SearchInput
        value={searchQuery}
        onValueChange={setSearchQuery}
        placeholder="Filter plants..."
        className="w-full sm:max-w-[300px]"
      />
      {isFiltered && (
        <Button
          variant="ghost"
          onClick={() => {
            setSearchQuery('');
          }}
          className="h-8 w-min px-2 lg:px-3"
        >
          Clear
          <Cross2Icon className="ml-2 h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
